import React, { Component } from 'react';
import ReactRandomSquaresAvatar from 'react-random-squares-avatar';
import './surface_styles.css';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">

        <div className="container g--12">
          <div className="card m--1 g--10">
            <div className="container">
              <div className="App-header">
                <h2>Welcome to React Random Squares Avatar</h2>
              </div>
            </div>

            <div className="container">
              <div className="g--12">
                <h4>Get started:</h4>
                <p>
                  Install from npm
                </p>
                <p>
                  <code>npm install react-random-squares-avatar --save</code>
                </p>
                <h4>Usage:</h4>
                <p>
                  If no props are supplied then the default height and width are 100px and the rotation will be a random
                  10 digit number in the range of 10 degrees to 80 degrees inclusive.
                </p>
                <p>
                  <code>&lt;ReactRandomSquaresAvatar /&gt;</code>
                </p>
                <p>
                  The props height and width set the avatars dimensions and the rotate value can be either 0, or a
                  10 digit number in the range of 10 degrees to 80 degrees inclusive.
                </p>
                <p>
                  <code>&lt;ReactRandomSquaresAvatar height="200" width="200" rotate="0" /&gt;</code>
                  <br />
                  <code>&lt;ReactRandomSquaresAvatar height="200" width="200" rotate="80" /&gt;</code>
                </p>
              </div>
           </div>
           <div className="container">
             <h4>Examples:</h4>
           </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar />
                &lt;ReactRandomSquaresAvatar /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar rotate="0" />
                &lt;ReactRandomSquaresAvatar rotate="0" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar rotate="40"  />
                &lt;ReactRandomSquaresAvatar rotate="40" /&gt;
              </div>
            </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="200" />
                &lt;ReactRandomSquaresAvatar height="200" width="200" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="200" rotate="0" />
                &lt;ReactRandomSquaresAvatar height="200" width="200" rotate="0" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="200" rotate="80" />
                &lt;ReactRandomSquaresAvatar height="200" width="200" rotate="80" /&gt;
              </div>
            </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar height="100" width="200" />
                &lt;ReactRandomSquaresAvatar height="100" width="200" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar height="100" width="200" rotate="0" />
                &lt;ReactRandomSquaresAvatar height="100" width="200" rotate="0" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar height="100" width="200" rotate="70" />
                &lt;ReactRandomSquaresAvatar height="100" width="200" rotate="70" /&gt;
              </div>
            </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="100" />
                &lt;ReactRandomSquaresAvatar height="200" width="100" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="100" rotate="0" />
                &lt;ReactRandomSquaresAvatar height="200" width="100" rotate="0" /&gt;
              </div>
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="100" rotate="20" />
                &lt;ReactRandomSquaresAvatar height="200" width="100" rotate="20" /&gt;
              </div>
            </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar height="200" width="400" />
                &lt;ReactRandomSquaresAvatar height="200" width="400" /&gt;
              </div>
            </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar height="400" width="200" />
                &lt;ReactRandomSquaresAvatar height="400" width="200" /&gt;
              </div>
            </div>
            <div className="container">
              <div className="g--6">
                <ReactRandomSquaresAvatar height="400" width="400" />
                &lt;ReactRandomSquaresAvatar height="400" width="400" /&gt;
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js